import {
    exportAppendixDeleteNumberCallStack,
    exportAppendixDeleteNumberZenify,
    exportDetailSub,
    exportDetailSubAppendix,
    exportDetailSubAppendixZenify,
    exportReconAgencyPayCallStack,
    exportReconAgencyPayZenify,
    exportReconSub,
    exportReconSubSystem,
    exportReconSubSystemNew,
    exportReconSubSystemNewZenify,
    exportReconSubSystemPayZenify,
    exportReconSubSystemZenify,
    exportReconSubZenify,
    exportReconSystemPayCallStack, exportReportHistoryPayment,
    exportSubscriberUsage,
    exportSubscriberUsageZenify
} from "../../../../services/api/apiReport2";

export const EXPORT_BUTTONS_CONFIG = {
    standard: [
        {
            id: 'export-recon',
            apiFunction: exportReconSub,
            buttonText: 'Export đối soát đại lý',
            fileName: 'doi_soa_dai_ly.xlsx',
            needsLevel: true,
            needsTenantName: true,
            group: 'standard'
        },
        {
            id: 'export-recon-system',
            apiFunction: exportReconSubSystem,
            buttonText: 'Export đối soát dữ liệu hệ thống',
            fileName: 'doi_soa_he_thong.xlsx',
            needsLevel: false,
            needsTenantName: false,
            group: 'standard'
        },
        {
            id: 'export-recon-from-system',
            apiFunction: exportReconSubSystemNew,
            buttonText: 'Export thông báo cước dữ liệu hệ thống',
            fileName: 'thong_bao_cuoc_he_thong.xlsx',
            needsLevel: false,
            needsTenantName: false,
            group: 'standard'
        },
        {
            id: 'export-detail',
            apiFunction: exportDetailSub,
            buttonText: 'Export chi tiết sub',
            fileName: 'chi_tiet_sub.xlsx',
            needsLevel: true,
            needsTenantName: true,
            group: 'standard'
        },
        {
            id: 'export-appendix',
            apiFunction: exportDetailSubAppendix,
            buttonText: 'Export phụ lục',
            fileName: 'phu_luc.xlsx',
            needsLevel: true,
            needsTenantName: true,
            group: 'standard'
        },
        {
            id: 'export-subscriber',
            apiFunction: exportSubscriberUsage,
            buttonText: 'Export biên bản bàn giao thuê bao sử dụng',
            fileName: 'bien_ban_ban_giao.xlsx',
            needsLevel: true,
            needsTenantName: true,
            group: 'standard'
        },
        {
            id: 'export-request-pay-system-callstack',
            apiFunction: exportReconSystemPayCallStack,
            buttonText: 'Export đề nghị thanh toán Callstack(Hệ thống)',
            fileName: 'de_nghi_thanh_toan_callstack_he_thong.xlsx',
            needsLevel: true,
            needsTenantName: true,
            group: 'standard'
        },
        {
            id: 'export-request-pay-agency-callstack',
            apiFunction: exportReconAgencyPayCallStack,
            buttonText: 'Export đề nghị thanh toán Callstack(Đại lý)',
            fileName: 'de_nghi_thanh_toan_callstack_dai_ly.xlsx',
            needsLevel: true,
            needsTenantName: true,
            group: 'standard'
        },
        {
            id: 'export-appendix-delete_number-callstack',
            apiFunction: exportAppendixDeleteNumberCallStack,
            buttonText: 'Export phụ lục hủy số Callstack',
            fileName: 'phu_luc_huy_so_callstack.xlsx',
            needsLevel: true,
            needsTenantName: true,
            group: 'standard'
        }
    ],
    zenify: [
        {
            id: 'export-recon-zenify',
            apiFunction: exportReconSubZenify,
            buttonText: 'Export đối soát đại lý Zenify',
            fileName: 'doi_soat_dai_ly_zenify.xlsx',
            needsLevel: true,
            needsTenantName: true,
            group: 'zenify'
        },
        {
            id: 'export-recon-system-zenify',
            apiFunction: exportReconSubSystemZenify,
            buttonText: 'Export đối soát lấy dữ liệu hệ thống Zenify',
            fileName: 'doi_soa_he_thong_zenify.xlsx',
            needsLevel: false,
            needsTenantName: false,
            group: 'zenify'
        },
        {
            id: 'export-appendix-zenify',
            apiFunction: exportDetailSubAppendixZenify,
            buttonText: 'Export phụ lục Zenify',
            fileName: 'phu_luc_zenify.xlsx',
            needsLevel: true,
            needsTenantName: true,
            group: 'zenify'
        },
        {
            id: 'export-subscriber-zenify',
            apiFunction: exportSubscriberUsageZenify,
            buttonText: 'Export biên bản bàn giao đầu số sử dụng Zenify',
            fileName: 'bien_ban_ban_giao_zenify.xlsx',
            needsLevel: true,
            needsTenantName: true,
            group: 'zenify'
        },
        {
            id: 'export-recon-from-system-zenify',
            apiFunction: exportReconSubSystemNewZenify,
            buttonText: 'Export thông báo cước dữ liệu hệ thống Zenify',
            fileName: 'thong_bao_cuoc_he_thong_zenify.xlsx',
            needsLevel: false,
            needsTenantName: false,
            group: 'zenify'
        },
        {
            id: 'export-pay-from-system-zenify',
            apiFunction: exportReconSubSystemPayZenify,
            buttonText: 'Export đề nghị thanh toán Zenify(Hệ thống)',
            fileName: 'de_nghi_thanh_toan_zenify_he_thong.xlsx',
            needsLevel: false,
            needsTenantName: false,
            group: 'zenify'
        },
        {
            id: 'export-pay-from-agency-zenify',
            apiFunction: exportReconAgencyPayZenify,
            buttonText: 'Export đề nghị thanh toán Zenify(Đại lý)',
            fileName: 'de_nghi_thanh_toan_zenify_dai_ly.xlsx',
            needsLevel: false,
            needsTenantName: false,
            group: 'zenify'
        },
        {
            id: 'export-appendix-delete-number-zenify',
            apiFunction: exportAppendixDeleteNumberZenify,
            buttonText: 'Export phụ lục huý số Zenify',
            fileName: 'phu_luc_huy_so_zenify.xlsx',
            needsLevel: false,
            needsTenantName: false,
            group: 'zenify'
        }
    ],
    another:[
        {
            id: 'export-history-payment',
            apiFunction: exportReportHistoryPayment,
            buttonText: 'Lịch sử nạp cước',
            fileName: 'lich_su_nap_cuoc.xlsx',
            needsLevel: false,
            needsTenantName: false,
            group: 'another'
        },
    ]
}